module.exports = __webpack_public_path__ + "static/media/12.5192a2d9.jpg";